export default __webpack_public_path__ + "static/media/5.d499bfc6.svg";